import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class GameTitle extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT * .225;

        this.scaleY = GameVars.scaleY;

        const titleCandy = new Phaser.GameObjects.Image(this.scene, 0, -50, "texture_atlas_3", "title_candy");
        titleCandy.angle = -2;
        this.add(titleCandy);

        const titleFiesta = new Phaser.GameObjects.Image(this.scene, 0, -40, "texture_atlas_4", "title_fiesta");
        titleFiesta.angle = 1;
        this.add(titleFiesta);

        this.scene.tweens.add({
            targets: titleCandy,
            scaleX: 1.05,
            scaleY: .95,
            angle: 1,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 300,
            repeat: -1,
            yoyo: true
        });

        this.scene.tweens.add({
            targets: titleFiesta,
            scaleX: .95,
            scaleY: 1.05,
            angle: -1,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 300,
            repeat: -1,
            yoyo: true
        });
    }
}
